import React, { memo, useEffect } from 'react';

import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  APPLY_UNDO_BUTTON_LABEL,
  APPLY_UNDO_TOAST_LABEL,
  APPLY_UNDO_TOAST_TIMEOUT_MS,
} from './GenerateExpression.constants';
import { applyUndoToastSpacerStyles, applyUndoToastStyles } from './GenerateExpression.styles';
import { GenerateExpressionTestIds } from './GenerateExpression.testIds';

const ApplyUndoToast = ({ onDismiss, onUndo }) => {
  useEffect(() => {
    const timeout = setTimeout(onDismiss, APPLY_UNDO_TOAST_TIMEOUT_MS);

    return () => clearTimeout(timeout);
  }, [onDismiss]);

  return (
    <Box data-testid={GenerateExpressionTestIds.MODAL_APPLY_UNDO_TOAST} sx={applyUndoToastStyles}>
      <Typography variant="regular14">{APPLY_UNDO_TOAST_LABEL}</Typography>
      <Box sx={applyUndoToastSpacerStyles} />
      <Button
        data-testid={GenerateExpressionTestIds.MODAL_APPLY_UNDO_BUTTON}
        variant="text"
        onClick={onUndo}
      >
        {APPLY_UNDO_BUTTON_LABEL}
      </Button>
    </Box>
  );
};

ApplyUndoToast.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onUndo: PropTypes.func.isRequired,
};

export default memo(ApplyUndoToast);
